<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    @if (nonDeletedFiles?.length > 0) {
        <div class="document-container"
             [class.grid]="hasGridUploadedDocContainer">
            @for (file of nonDeletedFiles; track file; let index = $index; let odd = $odd) {
                @if (!file.isDeleted) {
                    <div class="document"
                         [class.mt-24]="hasMargin"
                         [class.ml-16]="odd"
                         fxFlex fxLayout="column"
                         (mouseenter)="file.hover=true" (mouseleave)="file.hover=false">
                        <div fxLayout="row" fxLayoutAlign="center center" class="w-100 h-100">
                            <div fxLayout="column">
                                <ui-kit-svg class="i-24"
                                            [class.pointer]="isDownloadable(file)"
                                            (click)="downloadFile(file)"
                                            [name]="isDownloadable(file) && file.hover ? 'ic_download' : 'ic_document'"></ui-kit-svg>
                            </div>
                            <div class="text-no-wrap t4 ml-4 pr-8 overflow-hidden"
                                 [class.pointer]="isDownloadable(file)"
                                 (click)="downloadFile(file)"
                                 fxFlex>{{ file.fileName }}
                            </div>
                            <div fxLayout="column">
                                @if (!file.completed || file.hover) {
                                    <ui-kit-svg
                                        class="i-24 pointer"
                                        (click)="deleteFile(file)"
                                        name="ic_cross_dark">
                                    </ui-kit-svg>
                                }
                                @if (file.completed && !file.hover) {
                                    <ui-kit-svg
                                        class="i-24 c-primary-green-600"
                                        name="ic_checkmark_small">
                                    </ui-kit-svg>
                                }
                            </div>
                        </div>
                        <mat-progress-bar
                            class="w-100 progress"
                            color="primary"
                            mode="determinate"
                            [value]="file.progressLoaded"/>
                    </div>
                }
            }
        </div>
    }
    <ngx-dropzone #dropzone
                  fxHide
                  [fxShow]="mode === 'drop-zone' && !nonDeletedFiles?.length"
                  class="drop-zone"
                  [class.drop-zone-error]="hasError"
                  [class.mt-28]="hasMargin"
                  [ngClass]="dropZoneStyle"
                  [disabled]="disabled"
                  [multiple]="multiple"
                  [accept]="mimeTypes.join(',')"
                  [maxFileSize]="maxFileSize"
                  (cancel)="$event.stopPropagation()"
                  (change)="onFilesChanged($event)">
        <ngx-dropzone-label>
            <div fxLayout="column" fxLayoutAlign="center center">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <ui-kit-svg class="i-24" name="ic_attach"></ui-kit-svg>
                    <div class="ml-8 t-button">{{ label | translate }}</div>
                </div>
            </div>
        </ngx-dropzone-label>
    </ngx-dropzone>
    @if (mode === 'button' && !nonDeletedFiles?.length) {
        <ui-kit-button [label]="'i18n_af_buttonUploadFile' | translate"
                       [removePadding]="true"
                       type="text"
                       icon="ic_upload"
                       iconPosition="left"
                       (clickListener)="openPicker()"/>
    }
    <div class="c-primary-gray-600 t4 mt-8 pre-line">
        {{ hint | translate }}
    </div>
</div>
